import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/featured',
    name: 'Featured',
    component: () => import(/* webpackChunkName: "about" */ '../views/Featured.vue'),
  },

  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import(/* webpackChunkName: "about" */ '../views/Gallery.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
  },
]

const router = new VueRouter({
  // scroll on top on landing on new page
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: process.env.ENVIRONMENT != 'production' ? process.env.BASE_URL : process.env.BASE_URL_DEV,
  routes,
})

export default router
